<template>
  <div class="website-layout">
    <WebsiteHeader />
    <main class="website-content">
      <router-view />
    </main>
    <WebsiteFooter v-if="!hideFooter" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import WebsiteHeader from '@/components/WebsiteHeader.vue'
import WebsiteFooter from '@/components/WebsiteFooter.vue'
import { shouldShowMobileLayout } from '@/utils/deviceDetect'

export default {
  name: 'WebsiteLayout',
  components: {
    WebsiteHeader,
    WebsiteFooter
  },
  setup() {
    const route = useRoute()
    const hideFooter = computed(() => route.name === 'VerificationDetail' && shouldShowMobileLayout())

    return {
      hideFooter
    }
  }
}
</script>

<style scoped>
.website-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.website-content {
  flex: 1;
}
</style>
